import React, { useEffect } from "react";
import { AuthProvider, KioskProvider } from "../redux";


import AppContainer from "./AppContainer";
import VirtualKeyboard from "./VirtualKeyboard";

interface AppProps {
  disableVirtualKeyboard?: boolean;
  forceVirtualKeyboard?: boolean;
}

const isTactile = "ontouchstart" in window || navigator.maxTouchPoints > 0;

const App = ({
  disableVirtualKeyboard,
  forceVirtualKeyboard,
}: AppProps) => {
  useEffect(() => {
    // Completely remove the native virtual keyboard if this is wanted
    if (
      (forceVirtualKeyboard || !disableVirtualKeyboard) &&
      navigator.virtualKeyboard
    ) {
      navigator.virtualKeyboard.overlaysContent = false;
      navigator.virtualKeyboard.hide();
    }
  }, [forceVirtualKeyboard, disableVirtualKeyboard]);

  return (
    <React.Fragment>
      {forceVirtualKeyboard || (!disableVirtualKeyboard && isTactile) ? (
        <VirtualKeyboard />
      ) : (
        <React.Fragment />
      )}
      <AuthProvider>
        <KioskProvider>
          <AppContainer />
        </KioskProvider>
      </AuthProvider>
    </React.Fragment>
  );
};

export default App;
